export * from './baBackTop.component';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baBackTop/index.ts